import { decode, verify } from 'jsonwebtoken';

import { STAGE } from './app-global-values';

const PUBLIC_KEY_MAP = {
  beta: `
-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAh1CCeL/LxiwtshJcOBDO
xoRqPGV/FkdnS4j8EybNXuUj7Acm58qEcKEprXULhJZSLKW2SV3vUnDHNoxSvA5N
6Ql/6dmOWTYsS3TMRG7a3YAzKD9b32aUgfrpd5JxuqO5bSdijTZZZSKZzoiFFiXX
SSG7gYp9tWKBdK4uy32EJXl/Mi/gLkGS6zu10097cDrrd98rev411jaybw4+87bH
88hNqV0QF8yB9uvEEBgJXF5G8j/IdoqH+VfVcZY2IpQYA5USwISJ1UJtOMPywvYP
FHJwgg2okLVRcWzyFOUlxSxx2figz+cVz3zONr1Zw+/sSe6sfakDaxQ7gUDuB+zm
kQIDAQAB
-----END PUBLIC KEY-----
`,
  gamma: `
-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA0UE0dwT2QmTlhHQ31zZB
8f5qAWhiLvgoVYhF0Ob6R7jRSXBOR0Lz+fwuSddfwxQfq/oWFe36QDNNtZsxVwxm
IaEmpjCnwhtxrPNi51kxbU3wkHVibZwyzVdPw/U4yAXbH/dvv1EcYgiZ2z1akP5g
cUp5g+duJ7aiIRb6kJBV/DNrzqQNFmYPcvAec0AR7sfAfBD/+CKy2GvANBvkQZGw
dL/HNFaf9e4HM8inOQLTWUdO2SU8QNdUL2bKO0mF7oAo0jAKM+yH5Bx6PRhh5Dyh
ClQyyRJQ+PA8BmVtav7u0otv49tqJcNi9Y7BhOzBtnpRwdzCDKLl3QX6FfBV/iP6
EwIDAQAB
-----END PUBLIC KEY-----
`,
  prod: `
-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAtclQLiHC8Fsv3+M9toAx
D25ewEYq5OtqyCU7DQJxDCfsuS/qyN2IKMlLQoNVuaBZ3ioJmEA44IpeaS8EbqK9
L8YGC6GUdMB6WRoSv0WL8bQJzpa2+Y8qr3/tCjQRH4ASmjtM5Cy8LlXizoXnMHZ3
p5XGRFORU5B07nz1Hr8Fi0EkEvf1pZsKev01NBUOH/zfBjaNTSY+2mQnQA4EgBhi
TTVGLuV6qrCxItgG1JOV4ohnLmZJ8D6BPyims1KmbfHa+ZU4UjKFY28/JR12l0xM
YMzBm96EZRYesfDzdHD5nPhLSrh68x7dgmrFeQKTwbf6ZGQ4FA4A1GlpeGhmdeSY
lQIDAQAB
-----END PUBLIC KEY-----
    `,
};

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  PUBLIC_KEY_MAP['local'] = `
-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCY6JrrdJzBgignkWVXevG5AfZ7
fcEL9E+fTMvtlIXVJCf8PhIawHyM2Hy5lKRJcC9Lorbui/JdqFaFH1jt2IbA3O5E
cYJDXqu8O1hxweQSjI77i4C8na8BqTccP3rkTO0X8cpFlbd+1BxiTWOOojq/B/Yz
RXHeyg88VX9RhWBnOwIDAQAB
-----END PUBLIC KEY-----
`;
}

const PUBLIC_KEY = PUBLIC_KEY_MAP[STAGE];

const verifyToken = (token, ignoreExpiration = false) => {
  verify(token, PUBLIC_KEY, {
    algorithms: ['RS256'],
    ignoreExpiration: ignoreExpiration,
  });
};

// (now + 30 sec >= exp) is the same as (now >= exp - 30 sec)
export const isExpired = (token, verifyAsTsiNotExpired = true) => {
  if (!token || token === '') return true;

  if (verifyAsTsiNotExpired) {
    verifyToken(token, true);
  }

  const soon = Math.floor(Date.now() / 1000) + 30;
  const decoded = decode(token);

  return soon >= decoded.exp;
};

export const getPayloadAttribute = (token, attr, defaultReturnValue, verifyAsTsiNotExpired = true) => {
  if (!token || token === '') {
    return defaultReturnValue;
  }

  if (verifyAsTsiNotExpired) {
    verifyToken(token);
  }

  const decoded = decode(token);
  return decoded[attr];
};

export const getExpirationDate = (token, verifyAsTsiNotExpired = true) => {
  return getPayloadAttribute(token, 'exp', 0, verifyAsTsiNotExpired);
};
